/**
 * The Company Diary - non-operational scheduling: leave, maintenance, compliance
 * checks, supply runs, damage records.
 *
 * `allowRoles` mirrors the `company-diary-view` gate, field staff and contractors
 * included: they reach the page but the API narrows what they see to the entries
 * they created or are assigned to.
 */
export default [
    {
        path: '/scheduler/internal-diary',
        name: 'CompanyDiary',
        meta: {
            requiresAuth: true,
            allowRoles: [
                'SUPER',
                'MOVEPRO_ADMIN',
                'DEVELOPER',
                'OWNER',
                'ADMIN',
                'MANAGER',
                'OPS',
                'SALES',
                'FIELD_STAFF',
                'CONTRACTOR',
            ],
            denyRoles: null,
            title: 'Internal diary',
            fullWidth: true,
            fullHeight: true,
        },
        components: {
            default: () => import('@views/company-diary/CompanyDiaryIndex.vue'),
        },
    },
];
